export const API_BASE_URL = "https://wedluck.leorobotics.in/wedluk/"; //live db wedluckWebClient
// export const API_BASE_URL = "http://192.168.1.12:5001/wedluk/"; //live db

//METE DATA

export const GET_RELIGIONS =API_BASE_URL + "meta-data/religions";
export const GET_CASTES =API_BASE_URL + "meta-data/castes";
export const GET_COMMUNITITES =API_BASE_URL + "meta-data/communities";
export const GET_MARITAL_STATUS =API_BASE_URL + "meta-data/maritalstatus";
export const GET_SKIN_TONE =API_BASE_URL + "meta-data/skintone";
export const GET_PHYSHICAL_BUILD =API_BASE_URL + "meta-data/build";
export const GET_HABITS =API_BASE_URL + "meta-data/habits";
export const GET_HOBBIES =API_BASE_URL + "meta-data/hobbies";   
export const GET_RELATIONS =API_BASE_URL + "meta-data/relations";   
export const GET_QUALIFICATION =API_BASE_URL + "meta-data/qualification";
export const GET_LANGUAGE =API_BASE_URL + "meta-data/language";
export const GET_COUNTRIES = API_BASE_URL + "meta-data/countries-data";
export const COUNTRY_STATES = API_BASE_URL + "meta-data/country-states";
export const STATE_DISTRICTS = API_BASE_URL + "meta-data/state-districts";
export const DISTRICT_CITIES = API_BASE_URL + "meta-data/district-cities";   
export const GET_EVENTS = API_BASE_URL + "meta-data/events";   
export const GET_CLIENT_RELATIONS = API_BASE_URL + "meta-data/clientrelations";
export const GET_LEVEL1_CASTE = API_BASE_URL + "meta-data/level1castes";
export const GET_LEVEL2_CASTE = API_BASE_URL + "meta-data/level2castes";
export const GET_LEVEL3_CASTE = API_BASE_URL + "meta-data/level3castes";
export const GET_CASTE_NAME = API_BASE_URL + "meta-data/getCasteName";
export const GET_ALL_CASTE = API_BASE_URL + "meta-data/getAllCaste";
export const GET_ALL_COUNTRIES = API_BASE_URL + "meta-data/countries";
export const GET_STATES= API_BASE_URL + "meta-data/states";
export const GET_CITIES= API_BASE_URL + "meta-data/cities";
export const WEDLUK_COMMUNITY_DOCS= API_BASE_URL + "meta-data/getCommuniteDocs";
export const GOOGLE_LOGIN_API ="https://www.googleapis.com/oauth2/v3/userinfo"



//POST

//bUSINESS
export const CREATE_AGENT =API_BASE_URL + "bussiness/createAgent";
export const EDIT_AGENT =API_BASE_URL + "bussiness/editAgent";
export const CHECK_BUSINESS_NAME =API_BASE_URL + "bussiness/checkBusinessName";
//PROFILE
export const CREATE_USER =API_BASE_URL + "users/createProfile";
export const CREATE_PROFILE =API_BASE_URL + "profiles/createProfile";
export const EDIT_PROFILE = API_BASE_URL +"profiles/editProfile";
export const DELETE_PROFILE = API_BASE_URL +"profiles/delete-profile";
export const UPDATE_CLIENT_PREFERENCE = API_BASE_URL +"profiles/update-client-preference";
export const FORWARD_TO_CLIENT = API_BASE_URL +"profiles/forward-to-client";
export const CREATE_MATCHES_BY_PREFERENCE  = API_BASE_URL +"profiles/createMatchesByPreference";
export const UPDATE_MATCH= API_BASE_URL +"profiles/update-match-status";
export const CHECK_PHNO = API_BASE_URL +"profiles/check-phonenumber";
export const CHECK_EMAIL = API_BASE_URL +"profiles/check-email";
// USERS 
export const REGISTER_USER =API_BASE_URL + "users/registerUser";
export const LOG_IN = API_BASE_URL +"users/loginByPhoneNo";
export const LOG_IN_BYGOOGLE = API_BASE_URL +"users/loginByGoogle";
export const LOG_IN_BYEMAIL = API_BASE_URL +"users/loginByEmailPassWord";
export const SEND_SIGNUP_OTP = API_BASE_URL +"users/sendSignUpOtp";
export const VERIFY_OTP = API_BASE_URL +"users/verifyOtp";
export const FORGOT_PASSWORD = API_BASE_URL +"users/forgotPassword";
export const UPDATE_USER_PHOTO = API_BASE_URL + "users/upload-profile-image";
export const UPDATE_CLIENT_PHOTO = API_BASE_URL + "users/upload-clients-image";
export const UPDATE_CLIENT_VIDEO = API_BASE_URL + "users/upload-clients-video";
export const UPDATE_CLIENT_DOC = API_BASE_URL + "users/upload-clients-docs";
export const DELETE_CLIENT_PHOTO = API_BASE_URL + "users/delete-clients-image";
export const SET_MAIN_PROFILE_PHOTO = API_BASE_URL + "profiles/setMainProfilePhoto";
export const ACTIVE_PROFILE = API_BASE_URL + "profiles/isActiveProfile";
export const SEND_REQUEST = API_BASE_URL + "profiles/send-access-request";
export const DELETE_FAMILY_WEALTH = API_BASE_URL + "profiles/deleteWealth";
export const DISABLE_USER_ACCOUNT = API_BASE_URL + "users/disableAccount";
export const ENABLE_USER_ACCOUNT = API_BASE_URL + "users/enableAccount";
export const DELETE_USER_ACCOUNT = API_BASE_URL + "users/deleteAccount";
export const REPORT_ISSUES = API_BASE_URL + "users/reportIssue";


//CLIENTS
export const CREATE_CLIENT = API_BASE_URL +"clients/createClient";
export const EDIT_CLIENT = API_BASE_URL +"clients/editClient";


//GET
export const GET_PROFILES =API_BASE_URL + "profiles/getProfiles";
export const GET_PROFILES_BY_CLIENT =API_BASE_URL + "profiles/getProfilesByClient";
export const GET_USERBYID = API_BASE_URL +"users/getUserById";
export const GET_CLIENT = API_BASE_URL +"users/get-client";
export const GET_PROFILEBYID = API_BASE_URL +"profiles/getProfileByID";
export const GET_PROFILEBY_CLIENTCODE = API_BASE_URL +"profiles/getProfileByClientCode"
export const GET_PROFILE_ACTIVATION_BY_CODE = API_BASE_URL +"profiles/validateProfileActivation";
export const MATCHES_FOR_CLIENT = API_BASE_URL +"profiles/matchesForClient";
export const GET_CLIENT_PREFERENCE = API_BASE_URL +"profiles/get-client-preference";
export const GET_ALL_AGENTS = API_BASE_URL +"bussiness/getAllAgent";
export const GET_AGENT = API_BASE_URL +"bussiness/getAgent";
export const GET_REQUEST_STATUS = API_BASE_URL +"profiles/get-request-status";
export const CHECK_REQUEST_STATUS = API_BASE_URL +"profiles/check-request-status";
export const GET_NOTIFICATIONS = API_BASE_URL +"profiles/getNotifications";
export const GET_NOTIFICATIONS_PROFILES = API_BASE_URL +"profiles/getNotificationsForProfiles";

//Business
export const UPDATE_BUSINESS_LOGO= API_BASE_URL + "bussiness/upload-business-logo";
export const UPDATE_PROMOTIONAL_IMAGES = API_BASE_URL + "bussiness/upload-promotional-images";
export const CREATE_AGENT_REVIEW = API_BASE_URL + "bussiness/createAgentReview";
export const GET_AGENT_REVIEW = API_BASE_URL + "bussiness/getAgentReviewsByUserId";
export const GET_AGENT_REVIEW_BY_PROFILE = API_BASE_URL + "bussiness/getAgentReviewByProfile";
export const DELETE_PROMOTIONAL_IMAGES = API_BASE_URL + "bussiness/delete-promotional-image";

export const RESET_PASSWORD=API_BASE_URL+"users/resetPassword"